/* eslint-disable @typescript-eslint/no-explicit-any */
import { deepCopy } from '../../helpers';

/**
 * Schema update from version 9 to version 10
 * - Stacked stone surround material now supports per-role panel thickness
 * - Back/side panels are 1" thick, front panels remain 1.5"
 * - Side panel width is increased by 0.5" for stacked stone
 * - Old kitchens preserve their existing panel thicknesses (backward compatibility)
 *   by storing panel sizes in the serialized data which take precedence during hydration
 */
export const u10 = (blueprint: any): any => {
	console.log('schema-update:process-update:10:started');

	try {
		const updatedBlueprint = deepCopy(blueprint);
		updatedBlueprint.schemaVersion = 10;

		// Old kitchens: their panel sizes are already serialized in the data.
		// When hydrated, the Panel constructor reads size from dataIn (metadata.size),
		// which preserves the old thicknesses. The new per-role thickness logic
		// only applies when panels are rebuilt (new islands) or explicitly resized.
		// No data transformation needed -- the existing serialized panel sizes
		// act as the backward-compatibility mechanism.

		console.log('schema-update:process-update:10:completed');
		return updatedBlueprint;
	} catch (err) {
		console.error('schema-update:process-update:10:error', err);
		return null;
	}
};
